import { LoadingButton } from '@mui/lab';

const defaultSx = {
  borderRadius: '8px',
  py: 1.5,
  fontWeight: 700,
  fontSize: 18,
  boxShadow: '0 2px 8px rgba(79,124,247,0.12)',
  textTransform: 'none',
};

export default function ActionButton({ sx = {}, fullWidth = true, ...props }) {
  return (
    <LoadingButton
      color='primary'
      variant='contained'
      fullWidth={fullWidth}
      sx={{
        ...defaultSx,
        ...sx,
      }}
      {...props}
    />
  );
}
